import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const DocumentChecklist = () => {
  const [checkedItems, setCheckedItems] = useState({});
  const [selectedNationality, setSelectedNationality] = useState('General');

  const categories = [
    {
      title: 'Personal Identification',
      icon: 'User',
      items: [
        { id: 'passport', label: 'Valid passport (min 6 months validity)', required: true },
        { id: 'visa', label: 'UAE residence visa (if applicable)', required: false },
        { id: 'emirates_id', label: 'Emirates ID (if UAE resident)', required: false },
        { id: 'passport_photos', label: 'Passport-sized photographs (4 copies)', required: true },
      ]
    },
    {
      title: 'Financial Documents',
      icon: 'DollarSign',
      items: [
        { id: 'bank_statements', label: '6 months bank statements (all accounts)', required: true },
        { id: 'salary_cert', label: 'Salary certificate from employer', required: true },
        { id: 'employment_letter', label: 'Employment letter on company letterhead', required: true },
        { id: 'tax_returns', label: 'Last 2 years tax returns (self-employed)', required: false },
        { id: 'credit_report', label: 'Credit report from home country', required: false },
      ]
    },
    {
      title: 'Property Documents',
      icon: 'Home',
      items: [
        { id: 'mou', label: 'Signed MOU / Form F', required: true },
        { id: 'noc', label: 'NOC from developer', required: true },
        { id: 'title_deed', label: 'Current title deed (seller)', required: true },
        { id: 'floor_plan', label: 'Floor plan and property specifications', required: false },
        { id: 'service_charge', label: 'Service charge clearance certificate', required: true },
      ]
    },
    {
      title: 'Legal & Compliance',
      icon: 'Shield',
      items: [
        { id: 'poa', label: 'Power of Attorney (if buying remotely)', required: false },
        { id: 'marriage_cert', label: 'Marriage certificate (for joint purchase)', required: false },
        { id: 'company_docs', label: 'Company documents (for corporate purchase)', required: false },
        { id: 'source_of_funds', label: 'Source of funds declaration', required: true },
      ]
    },
  ];

  const toggleItem = (id) => {
    setCheckedItems(prev => ({ ...prev, [id]: !prev?.[id] }));
  };

  const totalItems = categories?.reduce((acc, cat) => acc + cat?.items?.length, 0);
  const checkedCount = Object.values(checkedItems)?.filter(Boolean)?.length;
  const progress = Math.round((checkedCount / totalItems) * 100);

  return (
    <div className="rounded-2xl p-6 md:p-8" style={{ background: 'rgba(10, 22, 40, 0.9)', border: '1px solid rgba(0, 212, 255, 0.2)' }}>
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl flex items-center justify-center" style={{ background: 'rgba(0, 212, 255, 0.1)', border: '1px solid rgba(0, 212, 255, 0.3)' }}>
            <Icon name="ClipboardList" size={20} color="#00D4FF" />
          </div>
          <div>
            <h3 className="text-lg font-bold" style={{ color: '#E8F4FF' }}>Documentation Checklist</h3>
            <p className="text-sm" style={{ color: '#6B9EC4' }}>Track your document preparation progress</p>
          </div>
        </div>
        <div className="text-right">
          <div className="text-2xl font-bold" style={{ color: '#00D4FF', fontFamily: "'JetBrains Mono', monospace" }}>{progress}%</div>
          <div className="text-xs" style={{ color: '#6B9EC4' }}>{checkedCount}/{totalItems} docs</div>
        </div>
      </div>
      <div className="mb-4 h-2 rounded-full" style={{ background: 'rgba(0, 212, 255, 0.1)' }}>
        <div className="h-2 rounded-full transition-all duration-500" style={{ width: `${progress}%`, background: 'linear-gradient(90deg, #00D4FF, #00FF88)' }} />
      </div>
      <div className="space-y-4">
        {categories?.map((cat, catIdx) => (
          <div key={catIdx}>
            <div className="flex items-center gap-2 mb-2">
              <Icon name={cat?.icon} size={14} color="#00D4FF" />
              <span className="text-sm font-semibold" style={{ color: '#E8F4FF' }}>{cat?.title}</span>
            </div>
            <div className="space-y-2">
              {cat?.items?.map((item) => (
                <button
                  key={item?.id}
                  onClick={() => toggleItem(item?.id)}
                  className="w-full flex items-center gap-3 p-3 rounded-xl text-left transition-all duration-200"
                  style={checkedItems?.[item?.id] ? { background: 'rgba(0, 255, 136, 0.06)', border: '1px solid rgba(0, 255, 136, 0.2)' } : { background: 'rgba(0, 212, 255, 0.03)', border: '1px solid rgba(0, 212, 255, 0.1)' }}
                >
                  <div className="w-5 h-5 rounded flex items-center justify-center flex-shrink-0" style={checkedItems?.[item?.id] ? { background: '#00FF88' } : { border: '2px solid rgba(0, 212, 255, 0.4)' }}>
                    {checkedItems?.[item?.id] && <Icon name="Check" size={12} color="#000" />}
                  </div>
                  <span className="text-sm flex-1" style={{ color: checkedItems?.[item?.id] ? '#6B9EC4' : '#E8F4FF', textDecoration: checkedItems?.[item?.id] ? 'line-through' : 'none' }}>{item?.label}</span>
                  {item?.required && <span className="text-xs px-1.5 py-0.5 rounded" style={{ background: 'rgba(255, 100, 100, 0.1)', color: '#FF6464', border: '1px solid rgba(255, 100, 100, 0.2)' }}>Required</span>}
                </button>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DocumentChecklist;